import { render } from "./TermsConditionsPage.vue?vue&type=template&id=6e4b2ef2&ts=true"
import script from "./TermsConditionsPage.vue?vue&type=script&lang=ts"
export * from "./TermsConditionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__